// Internal
import { markdownify } from "../../utils/markdown";

markdownify(document.getElementsByClassName("is-markdown"));

export const ViewReviewForm = () => {
	return null;
};
